<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    v-if="$route.path !== '/dashboard'"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <!-- <CSidebarBrand class="d-md-down-none" to="/">
      <CIcon 
        class="c-sidebar-brand-full" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 556 134"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 110 134"
      />
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="$options.nav"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    /> -->

    <!-- :class="index == num ? 'px-3 active' : 'px-3'" -->
    <!-- 虛擬卡頁 -->
    <div>
      <div class="item-box" v-if="$route.meta.isCardpage === true">
        <div class="item">
          <ul>
            <router-link to="/virtual-card/card-list" tag="li" class="box">
              <!-- <CIcon name="cil-grid" /> -->
              <i class="el-icon-bank-card" style="font-size:25px"></i>
              <div>{{ $t('ceNavbar.CardList') }}</div>
            </router-link>
          </ul>
        </div>
        <div class="item">
          <ul>
            <router-link
              to="/virtual-card/card-create?rid=1"
              tag="li"
              class="box"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width: 1.5rem;height:1.5rem; font-size: 1.5rem">
                <polygon
                  fill="var(--ci-primary-color, currentColor)"
                  points="440 240 272 240 272 72 240 72 240 240 72 240 72 272 240 272 240 440 272 440 272 272 440 272 440 240"
                  class="ci-primary"
                />
              </svg>
              <div>{{ $t('ceNavbar.Create') }}</div>
            </router-link>
          </ul>
        </div>
        <div class="item">
          <ul>
            <router-link to="/virtual-card/card-holder" tag="li" class="box">
              <!-- <CIcon name="cil-grid" /> -->
              <!-- <i class="el-icon-s-custom" style="font-size:25px"></i> -->
              <svg t="1756809223481" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5449" width="25" height="25"><path d="M510.138182 582.749091c-156.392727 0-283.461818-127.069091-283.461818-283.461818 0-156.392727 127.069091-283.461818 283.461818-283.461818s283.461818 127.069091 283.461818 283.461818c0 156.392727-127.069091 283.461818-283.461818 283.461818z m0-473.367273c-104.727273 0-190.370909 85.178182-190.370909 190.370909 0 104.727273 85.178182 190.370909 190.370909 190.370909s190.370909-85.178182 190.370909-190.370909c0-105.192727-85.643636-190.370909-190.370909-190.370909z" p-id="5450" fill="var(--ci-primary-color, currentColor)"></path><path d="M425.890909 985.367273H79.592727c-13.963636 0-26.996364-6.050909-35.84-16.756364s-12.567273-24.203636-10.24-37.701818l24.203637-139.636364c30.254545-175.010909 181.061818-301.614545 358.4-301.614545h108.450909c25.6 0 46.545455 20.945455 46.545454 46.545454s-20.945455 46.545455-46.545454 46.545455H416.581818c-132.189091 0-244.363636 94.487273-266.705454 224.349091L134.981818 892.276364h290.909091c25.6 0 46.545455 20.945455 46.545455 46.545454s-20.945455 46.545455-46.545455 46.545455zM953.716364 989.090909h-349.556364c-25.6 0-46.545455-20.945455-46.545455-46.545454v-256.465455c0-25.6 20.945455-46.545455 46.545455-46.545455h349.556364c25.6 0 46.545455 20.945455 46.545454 46.545455v256.465455c0 25.6-20.945455 46.545455-46.545454 46.545454z m-303.010909-93.090909h256.465454v-163.374545h-256.465454v163.374545z" p-id="5451" fill="var(--ci-primary-color, currentColor)"></path></svg>
              <div>{{ $t('ceNavbar.CardHolder') }}</div>
            </router-link>
          </ul>
        </div>
      </div>

      <!-- <CHeaderNav class="mr-auto" v-if="ldata.items == undefined">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink :to="ldata.to">
          <div>{{ldata.title}}</div>
          
        </CHeaderNavLink>
      </CHeaderNavItem>
      </CHeaderNav> -->

      <!-- <CHeaderNav class="mr-auto" v-else>
      <CHeaderNavItem v-for="(item,index) in ldata.items" :key="index" class="px-3">
        <CHeaderNavLink :to="item.to">
          <div>{{item.title}}</div>
          
        </CHeaderNavLink>
      </CHeaderNavItem>
      </CHeaderNav> -->
      <!-- 資金頁 -->
      <div class="item-box" v-if="$route.meta.isFundsPage === true">
        <div class="item">
          <ul>
            <router-link to="/funds/funds" tag="li" class="box">
              <div style="font-size: 1.3rem">$</div>
              <div>{{ $t('ceNavbar.Funds') }}</div>
            </router-link>
          </ul>
        </div>
        <!-- <div class="item">
          <ul>
            <router-link
              to="/funds/accounts"
              tag="li"
              class="box"
            >
              <svg style="width:1.3rem" xmlns="http://www.w3.org/2000/svg" class="icon icon-xxl" viewBox="0 0 512 512" role="img">undefined<path fill="var(--ci-primary-color, currentColor)" d="M247.759,14.358,16,125.946V184H496V125.638ZM464,152H48v-5.946L248.241,49.642,464,146.362Z" class="ci-primary"></path><rect width="416" height="32" x="48" y="408" fill="var(--ci-primary-color, currentColor)" class="ci-primary"></rect><rect width="480" height="32" x="16" y="464" fill="var(--ci-primary-color, currentColor)" class="ci-primary"></rect><rect width="32" height="160" x="56" y="216" fill="var(--ci-primary-color, currentColor)" class="ci-primary"></rect><rect width="32" height="160" x="424" y="216" fill="var(--ci-primary-color, currentColor)" class="ci-primary"></rect><rect width="32" height="160" x="328" y="216" fill="var(--ci-primary-color, currentColor)" class="ci-primary"></rect><rect width="32" height="160" x="152" y="216" fill="var(--ci-primary-color, currentColor)" class="ci-primary"></rect><rect width="32" height="160" x="240" y="216" fill="var(--ci-primary-color, currentColor)" class="ci-primary"></rect></svg>
              <div>{{ $t('ceNavbar.Accounts') }}</div>
            </router-link>
          </ul>
        </div> -->
      </div>

      <!-- 明細頁 -->
      <div class="item-box" v-if="$route.meta.isDetailPage === true">
        <div class="item">
          <ul>
            <router-link to="/card-detail/consumer-details" tag="li" class="box">
              <!-- <CIcon name="cil-grid" /> -->
              <i class="el-icon-bank-card" style="font-size:25px"></i>
              <div>{{ $t('ceNavbar.CardList') }}</div>
            </router-link>
          </ul>
        </div>
        <div class="item">
          <ul>
            <router-link
              to="/card-detail/account-flow"
              tag="li"
              class="box"
            >
              <!-- <CIcon name="cilUser" /> -->
              <i class="el-icon-user" style="font-size:25px"></i>
              <div>{{ $t('ceNavbar.Accounts') }}</div>
            </router-link>
          </ul>
        </div>
        <div class="item">
          <ul>
            <router-link
              to="/card-detail/report"
              tag="li"
              class="box"
            >
              <i class="el-icon-s-order" style="font-size:25px"></i>
              <div>{{ $t('ceNavbar.Report') }}</div>
            </router-link>
          </ul>
        </div>
      </div>

      <!-- 獎勵中心 -->
      <div class="item-box" v-if="$route.meta.isRewardCenterPage === true">
        <div class="item">
          <ul>
            <router-link to="/reward-center/account" tag="li" class="box">
              <!-- <i class="el-icon-user" style="font-size:25px"></i> -->
              <svg style="width:26px;height:26px" xmlns="http://www.w3.org/2000/svg" class="icon icon-xxl" viewBox="0 0 512 512" role="img">undefined<path fill="var(--ci-primary-color, currentColor)" d="M462.541,316.3l-64.344-42.1,24.774-45.418A79.124,79.124,0,0,0,432.093,192V120A103.941,103.941,0,0,0,257.484,43.523L279.232,67a71.989,71.989,0,0,1,120.861,53v72a46.809,46.809,0,0,1-5.215,21.452L355.962,284.8l89.058,58.274a42.16,42.16,0,0,1,19.073,35.421V432h-72v32h104V378.494A74.061,74.061,0,0,0,462.541,316.3Z" class="ci-primary"></path><path fill="var(--ci-primary-color, currentColor)" d="M318.541,348.3l-64.343-42.1,24.773-45.418A79.124,79.124,0,0,0,288.093,224V152A104.212,104.212,0,0,0,184.04,47.866C126.723,47.866,80.093,94.581,80.093,152v72a78,78,0,0,0,9.015,36.775l24.908,45.664L50.047,348.3A74.022,74.022,0,0,0,16.5,410.4L16,496H352.093V410.494A74.061,74.061,0,0,0,318.541,348.3ZM320.093,464H48.186l.31-53.506a42.158,42.158,0,0,1,19.073-35.421l88.682-58.029L117.2,245.452A46.838,46.838,0,0,1,112.093,224V152a72,72,0,1,1,144,0v72a46.809,46.809,0,0,1-5.215,21.452L211.962,316.8l89.058,58.274a42.16,42.16,0,0,1,19.073,35.421Z" class="ci-primary"></path></svg>
              <div>{{ $t('ceNavbar.RewardAccount') }}</div>
            </router-link>
          </ul>
        </div>
        <div class="item">
          <ul>
            <router-link
              to="/reward-center/rewards"
              tag="li"
              class="box"
            >
              <!-- <CIcon name="cilUser" /> -->
              <!-- <i class="el-icon-present" style="font-size:25px"></i> -->
              <svg style="width:26px;height:26px" xmlns="http://www.w3.org/2000/svg" class="icon icon-xxl" viewBox="0 0 512 512" role="img">undefined<path fill="var(--ci-primary-color, currentColor)" d="M489.972,119.059a23.839,23.839,0,0,0-17-7.059H456V72a24.027,24.027,0,0,0-24-24H86.627A70.628,70.628,0,0,0,16,118.627V393.373A70.628,70.628,0,0,0,86.627,464h385.4a24.047,24.047,0,0,0,24-23.923l.944-303.995A23.837,23.837,0,0,0,489.972,119.059ZM464.053,432H86.627A38.627,38.627,0,0,1,48,393.373V118.627A38.627,38.627,0,0,1,86.627,80H424v32H88v32H464.947Z" class="ci-primary"></path><rect width="32" height="32" x="392" y="264" fill="var(--ci-primary-color, currentColor)" class="ci-primary"></rect></svg>
              <div>{{ $t('ceNavbar.Rewards') }}</div>
            </router-link>
          </ul>
        </div>
        <div class="item">
          <ul>
            <router-link
              to="/reward-center/hierarchy"
              tag="li"
              class="box"
            >
              <!-- <CIcon name="cilChart" /> -->
              <!-- <i class="el-icon-user" style="font-size:25px"></i> -->
              <!-- <svg xmlns="http://www.w3.org/2000/svg" style="width:26px;height:26px" class="icon icon-xxl" viewBox="0 0 512 512" role="img">undefined<path fill="var(--ci-primary-color, currentColor)" d="M472,328H448V264a24.027,24.027,0,0,0-24-24H272V176h32a24.028,24.028,0,0,0,24-24V80a24.028,24.028,0,0,0-24-24H208a24.028,24.028,0,0,0-24,24v72a24.028,24.028,0,0,0,24,24h32v64H88a24.027,24.027,0,0,0-24,24v64H40a24.028,24.028,0,0,0-24,24v72a24.028,24.028,0,0,0,24,24h80a24.028,24.028,0,0,0,24-24V352a24.028,24.028,0,0,0-24-24H96V272H240v56H216a24.028,24.028,0,0,0-24,24v72a24.028,24.028,0,0,0,24,24h80a24.028,24.028,0,0,0,24-24V352a24.028,24.028,0,0,0-24-24H272V272H416v56H392a24.028,24.028,0,0,0-24,24v72a24.028,24.028,0,0,0,24,24h80a24.028,24.028,0,0,0,24-24V352A24.028,24.028,0,0,0,472,328ZM216,88h80v56H216ZM112,360v56H48V360Zm176,0v56H224V360Zm176,56H400V360h64Z" class="ci-primary"></path></svg> -->
              <svg style="width:26px;height:26px" xmlns="http://www.w3.org/2000/svg" class="icon icon-xxl" viewBox="0 0 512 512" role="img">undefined<path fill="var(--ci-primary-color, currentColor)" d="M124,136H36a20.023,20.023,0,0,0-20,20V476a20.023,20.023,0,0,0,20,20h88a20.023,20.023,0,0,0,20-20V156A20.023,20.023,0,0,0,124,136ZM112,464H48V168h64Z" class="ci-primary"></path><path fill="var(--ci-primary-color, currentColor)" d="M300,240H212a20.023,20.023,0,0,0-20,20V476a20.023,20.023,0,0,0,20,20h88a20.023,20.023,0,0,0,20-20V260A20.023,20.023,0,0,0,300,240ZM288,464H224V272h64Z" class="ci-primary"></path><path fill="var(--ci-primary-color, currentColor)" d="M476,16H388a20.023,20.023,0,0,0-20,20V476a20.023,20.023,0,0,0,20,20h88a20.023,20.023,0,0,0,20-20V36A20.023,20.023,0,0,0,476,16ZM464,464H400V48h64Z" class="ci-primary"></path></svg>
              <div>{{ $t('ceNavbar.Statistics') }}</div>
            </router-link>
          </ul>
        </div>
      </div>

      <!-- 子账户 -->
      <div class="item-box" v-if="$route.meta.isSubAccountPage === true">
        <div class="item">
          <ul>
            <router-link to="/account/sub-account" tag="li" class="box">
              <!-- <CIcon name="cil-grid" /> -->
              <i class="el-icon-user" style="font-size:25px"></i>
              <div>{{ $t('SubAccount.SubMenuAccounts') }}</div>
            </router-link>
          </ul>
        </div>
        <div class="item">
          <ul>
            <router-link
              to="/account/virtual-card"
              tag="li"
              class="box"
            >
              <!-- <CIcon name="cilUser" /> -->
              <i class="el-icon-bank-card" style="font-size:25px"></i>
              <div>{{ $t('SubAccount.SubMenuVirtualCard') }}</div>
            </router-link>
          </ul>
        </div>
        <div class="item">
          <ul>
            <router-link
              to="/account/transaction"
              tag="li"
              class="box"
            >
              <i class="el-icon-tickets" style="font-size:25px"></i>
              <div>{{ $t('SubAccount.SubMenuTransaction') }}</div>
            </router-link>
          </ul>
        </div>
        <div class="item">
          <ul>
            <router-link
              to="/account/history"
              tag="li"
              class="box"
            >
              <i class="el-icon-s-order" style="font-size:25px"></i>
              <div>{{ $t('SubAccount.SubMenuHistory') }}</div>
            </router-link>
          </ul>
        </div>
      </div>


    </div>
  </CSidebar>
</template>

<script>
import nav from "./_nav";
import TheHeader from "./TheHeader.vue";

export default {
  name: "TheSidebar",
  nav,
  props: ["ldata"],
  components: {
    TheHeader,
  },
  data() {
    return {
      list: [],
      items: [],
      to: "",
      na: "",
      // tempData
      // tempData: this.ldata
    };
  },
  created() {
    // console.log("ldata===>", this.ldata);
    // if (this.ldata.length == 0) {
    //   let obj = {};
    //   obj.to = this.$route.path;
    //   obj.title = this.$route.meta.label;
    //   this.ldata = obj;
    //   this.tempData = obj;
    // }
  },
  computed: {
    tempData: {
      get: function () {
        return this.ldata;
      },
      set: function (v) {
        console.log("v==>", v);
      },
    },
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
};
</script>
<style scoped>
ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.item-box {
  padding: 20px 0;
}
.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding-bottom: 20px;
}
.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: .3rem;
}
.act{
    border-bottom: 5px solid #00BEA4;
}
.router-link-exact-active {
    border-bottom: 5px solid #00BEA4;
    color: #7F7F8A;
    font-weight: bold;
    transition: all .5s;
}
</style>
